import { computed } from 'vue';

export const favoritePageProps = {
  view: {
    type: String,
    required: true,
    validator(value) {
      return [
        'cams',
        'daily-snows',
        'locations',
        'season-passes',
        'trail-maps',
        'weather-stations',
      ].includes(value);
    },
  },
};

export const useFavoritesPage = (props) => {
  const isCamsView = computed(() => props.view === 'cams');
  const isDailySnowsView = computed(() => props.view === 'daily-snows');
  const isLocationsView = computed(() => props.view === 'locations');
  const isSeasonPassesView = computed(() => props.view === 'season-passes');
  const isTrailMapsView = computed(() => props.view === 'trail-maps');
  const isWeatherStationsView = computed(() => props.view === 'weather-stations');

  return {
    isCamsView,
    isDailySnowsView,
    isLocationsView,
    isSeasonPassesView,
    isTrailMapsView,
    isWeatherStationsView,
  };
};
